<!-- eslint-disable -->
<template lang="pug">
    .education-banner
        .education-banner__header
            | {{ headerString }}
        divider(:margin="'0 auto'")
        .education-banner__body
            div(
                v-for="grade in displayedGrades"
                :key="grade.id"
            )
                grade(:grade="grade")
                divider(:margin="'0 auto'")
        games-buttons
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import Grade from './Grade.vue';
    import BillingBlockMixin from '../../../utils/user/BillingBlockMixin';
    import GamesButtons from './GamesButtons.vue'

    export default {
        components: {
            GamesButtons,
            Grade
        },
        mixins: [BillingBlockMixin],
        computed: {
            ...mapState({
                user: state => state.auth.user,
                selectedCourse: state => state.trainer.course
            }),
            headerString () {
                if (this.user.type === 'student') {
                    return this.$i18n.t('common.common_course_' + this.selectedCourse);
                } else if (this.user.type === 'teacher') {
                    return this.$i18n.t('dashboard.dashboard_appHeader_grades');
                }
                return this.$i18n.t('dashboard.dashboard_education_header')
            },
            displayedGrades () {
                if (this.user.type === 'student') {
                    return this.user.grades.filter(grade => _.camelCase(grade.course.type) === this.selectedCourse);
                }
                return this.user.grades;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .education-banner {
        padding: 30px;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .education-banner__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }

    .education-banner__body {
        font-size: 16px;
        line-height: 24px;
    }
</style>
